//リンク先選択画面
import React , { useEffect } from 'react'
import styled from 'styled-components'
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import { Grid, Typography, Button, Card } from '@material-ui/core'
import LinkIcon from '@material-ui/icons/Link'
import { WorkAreaStateType } from './BookEditor'
import { useDispatch } from 'react-redux'
import useOneCardDb from '../hooks/useOneCardDb'
import { setDefaultSheet } from '../redux/sheetDbSlice'
import useSheetTreeNamesForLink, {LinkSheetNameType} from '../hooks/useSheetTreeNamesForLink'
import useCurrentBookDb from '../hooks/useCurrentBookDb'

const LineCard = styled(Card)`
  padding: 8px;
  margin: 8px;
  transition: background-color 300ms;
  &:hover {
    background-color: #f5f5f5;
    cursor: pointer;
  }
`
const LargeLinkIcon = styled(LinkIcon)`
  position: relative;
  top: 8px;
  font-size: 32px;
`

type JumpLinkDialogProps = {
  open: boolean
  onClose: () => void
  id?: string
  nodeClicked: (workArea: WorkAreaStateType, id?: string) => void
}
const JumpLinkDialog: React.FC<JumpLinkDialogProps> = ({open, onClose, id, nodeClicked}) => {
  const dispatch = useDispatch();
  const card = useOneCardDb(id);
  const bookDb = useCurrentBookDb();
  const linkedSheetNames:LinkSheetNameType[] = useSheetTreeNamesForLink(bookDb?.name, card?.links);

  const jumpToLinkedSheet = (sheetId:string) => {
    nodeClicked('sheet', sheetId);
    dispatch(setDefaultSheet(sheetId));
    onClose();
  }

  useEffect(() => { //リンク先が一つなら、選択画面を開かずにそのシートに飛ぶ
    if(linkedSheetNames.length === 1) {
      if(card && card.links)
        jumpToLinkedSheet(card.links[0])
    }
  }, [linkedSheetNames])

  return (
    <Dialog open={open} onClose={onClose} maxWidth='lg' fullWidth>
      <DialogTitle>クリックするとリンク先のシートへジャンプします</DialogTitle>
      <DialogContent>
        { card?.links?.map((linkedSheetId, index) => {
          return(
          <LineCard>
            <Grid container spacing={1} onClick={() => jumpToLinkedSheet(linkedSheetId)}>
              <Grid container>
                <Grid item xs={1}><LargeLinkIcon /></Grid>
                <Grid item xs={11}>
                    <Typography variant="caption">{linkedSheetNames[index].linkTreeName}</Typography>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={1}></Grid>
                <Grid item xs={11}>
                  <Typography variant="body1">{linkedSheetNames[index].sheetName}</Typography>
                </Grid>
              </Grid>
            </Grid>
          </LineCard>
        )
        })}
      </DialogContent>
      <DialogActions>
        <Button variant='text' color='primary' onClick={onClose}>
          キャンセル
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default JumpLinkDialog;
